import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import _ from 'lodash'

import { cloudhelpPatch } from 'Utilities/CloudHelp'

class RegionSelector extends Component {
  constructor (props) {
    super()

    this.state = {
      chosenRegionId: props.chosenRegionId
    }
  }

  changeRegion (option) {
    const { sessionEndpoint } = this.props
    this.setState({ chosenRegionId: option.value })
    // Stops all active request on the page so that we don't have to wait to change the region
    window.stop()

    cloudhelpPatch(sessionEndpoint, { region_id: option.value })
      .then((response) => {
        window.location.reload(false)
      })
  }

  render () {
    const { chosenRegionId } = this.state
    const { regions } = this.props
    const regionsOptions = _.map(
      regions,
      region => ({ key: region.name, value: region.id, label: region.name })
    )

    const options = [{ key: 'Global', value: null, label: 'Global' }, ...regionsOptions]

    return (
      <Select
        options={options}
        value={_.find(options, ['value', chosenRegionId])}
        onChange={option => this.changeRegion(option)}
      />
    )
  }
}

RegionSelector.defaultProps = {
  chosenRegionId: null,
  regions: []
}

RegionSelector.propTypes = {
  chosenRegionId: PropTypes.number,
  sessionEndpoint: PropTypes.string.isRequired,
  regions: PropTypes.arrayOf(PropTypes.shape)
}

export default RegionSelector
